module.exports = __webpack_public_path__ + "fonts/Quicksand-400-latin-ext5.29b81f3.woff2";